class MegaMenuGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.track = gallery.querySelector('.mega-menu-gallery-track');
    this.items = this.track?.querySelectorAll('.mega-menu-gallery-item');
    this.wrapper = gallery.closest('.mega-menu-gallery-wrapper');
    this.prevBtn = this.wrapper?.querySelector('.mega-menu-gallery-nav--prev');
    this.nextBtn = this.wrapper?.querySelector('.mega-menu-gallery-nav--next');
    this.visibleCount = parseInt(gallery.dataset.visibleCount) || 5;
    
    if (!this.prevBtn || !this.nextBtn || !this.items?.length) return;
    
    this.currentIndex = 0;
    this.maxIndex = Math.max(0, this.items.length - this.visibleCount);
    
    this.init();
  }
  
  init() {
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());
    window.addEventListener('resize', () => this.update());
    this.update();
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.update();
    }
  }
  
  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.update();
    }
  }
  
  update() {
    const itemWidth = this.items[0].offsetWidth;
    const gap = 16;
    const offset = this.currentIndex * (itemWidth + gap);
    this.track.style.transform = `translateX(-${offset}px)`;
    
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    
    this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
    this.nextBtn.style.opacity = this.currentIndex >= this.maxIndex ? '0.3' : '1';
  }
}

class MegaMenuProducts {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.mega-menu-products-track');
    this.items = this.track?.querySelectorAll('.mega-menu-product-item');
    this.wrapper = container.closest('.mega-menu-products-wrapper');
    this.prevBtn = this.wrapper?.querySelector('.mega-menu-products-nav--prev');
    this.nextBtn = this.wrapper?.querySelector('.mega-menu-products-nav--next');
    this.visibleCount = parseInt(container.dataset.visibleCount) || 5;
    
    if (!this.prevBtn || !this.nextBtn || !this.items?.length) return;
    
    this.currentIndex = 0;
    this.maxIndex = Math.max(0, this.items.length - this.visibleCount);
    
    this.init();
  }
  
  init() {
    this.prevBtn.addEventListener('click', () => this.prev());
    this.nextBtn.addEventListener('click', () => this.next());
    window.addEventListener('resize', () => this.update());
    this.update();
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.update();
    }
  }
  
  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.update();
    }
  }
  
  update() {
    const itemWidth = this.items[0].offsetWidth;
    const gap = 16;
    const offset = this.currentIndex * (itemWidth + gap);
    this.track.style.transform = `translateX(-${offset}px)`;
    
    this.prevBtn.disabled = this.currentIndex === 0;
    this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    
    this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
    this.nextBtn.style.opacity = this.currentIndex >= this.maxIndex ? '0.3' : '1';
  }
}

class MegaMenuCollectionProducts {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.mega-menu-products-track');
    this.wrapper = container.closest('.mega-menu-products-wrapper');
    this.prevBtn = this.wrapper?.querySelector('.mega-menu-products-nav--prev');
    this.nextBtn = this.wrapper?.querySelector('.mega-menu-products-nav--next');
    this.visibleCount = parseInt(container.dataset.visibleCount) || 5;
    this.collectionItems = container.closest('.mega-menu-collection-products').querySelectorAll('.mega-menu-collection-item');
    this.isMobile = container.dataset.isMobile === 'true';
    this.isGrid = container.classList.contains('mega-menu-products--grid');
    
    if (!this.track || !this.collectionItems.length) return;
    
    this.currentIndex = 0;
    this.currentProducts = [];
    this.maxIndex = 0;
    
    this.productsLimit = parseInt(this.container.closest('.mega-menu-collection-products').dataset.productsLimit) || 10;
    this.showPrice = this.container.closest('.mega-menu-collection-products').dataset.showPrice === 'true';
    this.showVendor = this.container.closest('.mega-menu-collection-products').dataset.showVendor === 'true';
    this.showCart = this.container.closest('.mega-menu-collection-products').dataset.showCart === 'true';
    
    this.init();
  }
  
  init() {
    this.collectionItems.forEach((item, index) => {
      const button = item.querySelector('.mega-menu-collection-link');
      if (!button) return;
      
      if (!this.isMobile) {
        button.addEventListener('mouseenter', () => this.loadCollection(index));
      } else {
        button.addEventListener('click', () => {
          this.loadCollection(index);
          this.collectionItems.forEach(i => i.classList.remove('active'));
          item.classList.add('active');
        });
      }
    });
    
    if (this.prevBtn && this.nextBtn && !this.isGrid) {
      this.prevBtn.addEventListener('click', () => this.prev());
      this.nextBtn.addEventListener('click', () => this.next());
      window.addEventListener('resize', () => this.updateNavigation());
    }
    
    this.loadCollection(0);
  }
  
  loadCollection(index) {
    const item = this.collectionItems[index];
    if (!item) return;
    
    const dataScript = item.querySelector('script[data-collection-products]');
    if (!dataScript) return;
    
    try {
      const collectionData = JSON.parse(dataScript.textContent);
      this.currentProducts = collectionData.products;
      this.renderProducts();
      
      this.collectionItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
    } catch (e) {
      console.error('Error loading collection:', e);
    }
  }
  
  renderProducts() {
    if (!this.currentProducts.length) {
      this.track.innerHTML = '<p class="mega-menu-no-products">No products found</p>';
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      return;
    }
    
    if (this.prevBtn) this.prevBtn.style.display = '';
    if (this.nextBtn) this.nextBtn.style.display = '';
    
    this.currentIndex = 0;
    this.maxIndex = Math.max(0, this.currentProducts.length - this.visibleCount);
    
    this.track.innerHTML = this.currentProducts.map(product => this.createProductCard(product)).join('');
    
    if (!this.isGrid) {
      this.updateNavigation();
    }
  }
  
  createProductCard(product) {
    const priceHtml = this.showPrice ? `
      <div class="mega-menu-product-price">
        ${product.compare_at_price && product.compare_at_price > product.price ? `
          <span class="price price--on-sale">${this.formatMoney(product.price)}</span>
          <s class="price price--compare">${this.formatMoney(product.compare_at_price)}</s>
        ` : `
          <span class="price">${this.formatMoney(product.price)}</span>
        `}
      </div>
    ` : '';
    
    const vendorHtml = this.showVendor && product.vendor ? `
      <p class="mega-menu-product-vendor text-xs text-subdued">${product.vendor}</p>
    ` : '';
    
    const imageHtml = product.featured_image 
      ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">`
      : `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-25.3 14.5 18 2.5-3.2 12.5-15.8 26.8 33.9v.1h.1l.2.3H212l.2-.3v.3zm73.5-1.8-20.7-26.2 8.1-10.2 21.6 27.3v9.1h-9zm2.7-47h.1v.1l-.1-.1zm-68.6 0v.6l.2-.6h-.2zm-1.7 67.2v-63.9H289v63.9h-71.9z"/></svg>`;
    
    const cartHtml = this.showCart ? `
      <div class="mega-menu-product-actions">
        <form method="post" action="/cart/add">
          <input type="hidden" name="id" value="${product.variant_id}">
          <button type="submit" class="mega-menu-product-add-btn" ${!product.available ? 'disabled' : ''}>
            ${product.available ? (typeof Shopify !== 'undefined' && Shopify.translation && Shopify.translation.add_to_cart ? Shopify.translation.add_to_cart : 'Add to cart') : (typeof Shopify !== 'undefined' && Shopify.translation && Shopify.translation.sold_out ? Shopify.translation.sold_out : 'Sold out')}
          </button>
        </form>
      </div>
    ` : '';
    
    return `
      <div class="mega-menu-product-item">
        <a href="${product.url}" class="mega-menu-product-link">
          <div class="mega-menu-product-image">
            ${imageHtml}
          </div>
          <div class="mega-menu-product-info">
            ${vendorHtml}
            <p class="mega-menu-product-title">${product.title}</p>
            ${priceHtml}
          </div>
        </a>
        ${cartHtml}
      </div>
    `;
  }
  
  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }
  
  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateNavigation();
    }
  }
  
  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updateNavigation();
    }
  }
  
  updateNavigation() {
    const items = this.track.querySelectorAll('.mega-menu-product-item');
    if (!items.length) return;
    
    const itemWidth = items[0].offsetWidth;
    const gap = 16;
    const offset = this.currentIndex * (itemWidth + gap);
    this.track.style.transform = `translateX(-${offset}px)`;
    
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
      
      this.prevBtn.style.opacity = this.currentIndex === 0 ? '0.3' : '1';
      this.nextBtn.style.opacity = this.currentIndex >= this.maxIndex ? '0.3' : '1';
    }
  }
}

class MegaMenuAccordion extends HTMLElement {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.mega-menu-accordion-content');
    this.icon = this.querySelector('.mega-menu-accordion-icon');
    
    if (!this.details || !this.content) return;
    
    this.details.addEventListener('toggle', () => {
      if (this.details.open) {
        this.openAccordion();
      } else {
        this.closeAccordion();
      }
    });
    
    this.content.style.maxHeight = '0px';
    this.content.style.opacity = '0';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease';
    this.content.style.display = 'block';
    this.content.style.position = 'relative';
  }
  
  openAccordion() {
    requestAnimationFrame(() => {
      const contentHeight = this.content.scrollHeight;
      this.content.style.maxHeight = contentHeight + 'px';
      this.content.style.opacity = '1';
      
      if (this.icon) {
        this.icon.style.transform = 'rotate(90deg)';
      }
      
      setTimeout(() => {
        if (this.details.open) {
          this.content.style.maxHeight = 'none';
          this.content.style.overflow = 'visible';
        }
      }, 450);
    });
  }
  
  closeAccordion() {
    const contentHeight = this.content.scrollHeight;
    this.content.style.maxHeight = contentHeight + 'px';
    this.content.style.overflow = 'hidden';
    this.content.style.opacity = '1';
    
    if (this.icon) {
      this.icon.style.transform = 'rotate(0deg)';
    }
    
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.content.style.maxHeight = '0px';
        this.content.style.opacity = '0';
      });
    });
  }
}

function initMegaMenu() {
  document.querySelectorAll('.mega-menu-gallery:not(.mega-menu-gallery--grid)').forEach(gallery => {
    new MegaMenuGallery(gallery);
  });
  
  document.querySelectorAll('.mega-menu-products:not(.mega-menu-products--grid)').forEach(container => {
    if (!container.closest('.mega-menu-collection-products')) {
      new MegaMenuProducts(container);
    }
  });
  
  document.querySelectorAll('.mega-menu-collection-products .mega-menu-products').forEach(container => {
    new MegaMenuCollectionProducts(container);
  });
  
  if (!customElements.get('mega-menu-accordion')) {
    customElements.define('mega-menu-accordion', MegaMenuAccordion);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMegaMenu);
} else {
  initMegaMenu();
}